var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pkuna/map-pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8145 6.99971C10.6053 6.99971 8.81445 8.79057 8.81445 10.9997C8.81445 13.2088 10.6053 14.9997 12.8145 14.9997C15.0236 14.9997 16.8145 13.2088 16.8145 10.9997C16.8145 8.79057 15.0236 6.99971 12.8145 6.99971ZM10.8145 10.9997C10.8145 9.89514 11.7099 8.99971 12.8145 8.99971C13.919 8.99971 14.8145 9.89514 14.8145 10.9997C14.8145 12.1043 13.919 12.9997 12.8145 12.9997C11.7099 12.9997 10.8145 12.1043 10.8145 10.9997Z",
    fill: "#2C3236"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1786 17.3638L14.9356 21.6068C14.373 22.1688 13.6101 22.4848 12.815 22.4848C12.0198 22.4848 11.2572 22.1691 10.6947 21.6072L6.45043 17.3639C5.19181 16.1052 4.33459 14.5015 3.98736 12.7556C3.64013 11.0098 3.81838 9.20025 4.49959 7.55574C5.18079 5.91123 6.33434 4.50565 7.81437 3.51674C9.29441 2.52783 11.0344 2 12.8145 2C14.5945 2 16.3345 2.52783 17.8145 3.51674C19.2946 4.50565 20.4481 5.91123 21.1293 7.55574C21.8105 9.20025 21.9888 11.0098 21.6416 12.7556C21.2943 14.5015 20.4372 16.1051 19.1786 17.3638ZM8.9255 5.17969C10.0766 4.41053 11.43 4 12.8145 4C14.1989 4 15.5523 4.41053 16.7034 5.17969C17.8545 5.94884 18.7518 7.04207 19.2816 8.32113C19.8114 9.60019 19.95 11.0076 19.68 12.3655C19.4099 13.7233 18.7433 14.9706 17.7644 15.9496L13.5217 20.1922C13.3342 20.3796 13.08 20.4848 12.815 20.4848C12.5499 20.4848 12.2957 20.3796 12.1082 20.1922L7.86458 15.9496C6.88571 14.9707 6.21899 13.7233 5.94893 12.3655C5.67887 11.0076 5.81751 9.60019 6.34733 8.32113C6.87716 7.04207 7.77437 5.94884 8.9255 5.17969Z",
    fill: "#2C3236"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.69566b6fd786a1676f58ea81dd46b4f8.svg";
export { ForwardRef as ReactComponent };